import React, { ReactElement, FormEvent } from 'react';

interface props {
    id: string,
    required?: boolean,
    isValid?: boolean,
    className?: string,
    value?: string | number | readonly string[],
    defaultValue?: string | number | readonly string[]
    onChange?: (e: FormEvent<HTMLInputElement>) => void,
    [key: string]: any,
}

const EmailInput = ({ id, required, isValid, className, value, defaultValue, onChange, ...rest }: props): ReactElement => (
    <input
        id={id}
        className={`${className} bg-white text-paragraph text-dark`}
        type="email"
        aria-required={required}
        aria-invalid={isValid === false}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        autoComplete="email"
        {...rest}
    />
);

EmailInput.defaultProps = {
    required: false,
    className: undefined,
    isValid: false,
    value: undefined,
    defaultValue: undefined,
    onChange: undefined
};

export default EmailInput;
